<script>
import gql from 'graphql-tag'

import {
  limit,
  join,
  truncate,
} from '@/filters'

const findBook = gql`
  query findBook($id: String) {
    livre(id: $id) {
      id
      titre
      ean13
      sous_titre
      description
      couverture: couverture_url
      auteurs {
        nom
      }
    }
  }
`
import coverBook from './cover-book.vue'

export default {
  name: 'Book',
  props: {
    id: {},
    skin: {
      default: 'default',
    },
  },
  data () {
    return {
      livre: null,
    }
  },
  apollo: {
    livre: {
        // returnPartialData: true,
      query: findBook,
      variables () {
        return {
          id: this.id,
        }
      },
      skip () {
        return !this.id
      },
    },
  },
  filters: {
    limit,
    join,
    truncate,
  },
  components: {
    coverBook,
  },
  computed: {
    auteurs () {
      return this.livre && this.livre.auteurs.map(({ nom }) => nom).slice(0, 2).join(', ')
    },
  },
}
</script>

<template lang="pug">

div.book-cover.skin.tl.flex(:class="`skin-${skin}`")
  cover-book.cover.w-25(:cover="livre && livre.couverture")
  template(v-if="livre")
    div.infos.flex-auto(style="width: 0;")
      h4.titre.b.f4.mb1.gray {{ livre.titre | truncate(38) }}
      h6.subtitl.auteurs.f4.silver.mb2
        b {{ auteurs }}
      div.desc.content.lh-copy.f5(v-html="livre.description")
    slot(:livre="livre")
</template>

<style lang="postcss" scoped>

  .book-default {
    &.skin-default {
      padding: 15px;
      text-align: left;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      // padding-top: 70%;
      /*& .title {
        font-size: 1.2em;
        color: rgb(97,97,97);
      }*/
      & .cover, & .coverplace {
        height: 70%;
        width: 100%;
        margin-bottom: 10px;
      }
      & .desc {
        display: none;
      }
      & .cover {
        height: 60%;
        box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        /*background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGklEQVQYV2NkYGD4D8SMQAwGcAY2AbBKDBUAVuYCBX45Xb8AAAAASUVORK5CYII=') repeat;*/
      }
      & .auteurs {
        /*color: rgb(56,56,56);*/
      }
      & .infos {
        flex: 0 0 25%;
        overflow: hidden;
      }
    }
    &.skin-preview {
      padding: 15px;
      text-align: left;
      // height: 100%;
      display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      position: relative;
      // padding-top: 70%;
      & .title {
        font-size: 1.6em;
        color: rgb(97,97,97);
      }
      & .cover {
        // height: 60%;
        margin-right: 2em;
        // box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.3);
      }
      & .auteurs {
        color: rgb(56,56,56);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// book-cover.vue?a150c396